import { render, staticRenderFns } from "./WashEditor.vue?vue&type=template&id=1213c5c5&scoped=true"
import script from "./WashEditor.vue?vue&type=script&lang=js"
export * from "./WashEditor.vue?vue&type=script&lang=js"
import style0 from "./WashEditor.vue?vue&type=style&index=0&id=1213c5c5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213c5c5",
  null
  
)

export default component.exports